import { postRequest, formDataRequest, getRequest } from "../libs/AxiosService.util";



export async function serviceUpdateProgram(params) {
  return await formDataRequest("programs/update", params);
}
export async function serviceGetProgram(params) {
  return await postRequest("programs", params);
}
export async function serviceProgramIsExist(params) {
  return await postRequest("programs/check", params);
}
export async function serviceGetProgramDetails(params) {
  return await postRequest("programs/detail", params);
}
export async function serviceGetProduct(params) {
  return await postRequest("programs/products", params);
}
export async function serviceDownloadSampleCSv(params) {
  return await getRequest("programs/products/import/sample", params);
}
export async function serviceDownloadMyDocSampleCSv(params) {
  return await getRequest("programs/doctors/import/sample", params);
}

export async function serviceProgramImportVerify (params) {
  return await formDataRequest('programs/products/import/verify', params);
}

export async function serviceProgramImportFile(params) {
  return await formDataRequest('programs/products/import', params);
}
export async function serviceProgramMyDocImportVerify (params) {
  return await formDataRequest('programs/doctors/import/verify', params);
}
export async function serviceGetProgramDoctor(params) {
  return await postRequest("programs/doctors", params);
}
export async function serviceProgramMyDocImportFile(params) {
  return await formDataRequest('programs/doctors/import', params);
}


export async function serviceCreateProgram(params) {
  return await formDataRequest("programs/create", params);
}

export async function serviceDeleteProgram(params) {
  return await formDataRequest("programs/delete", params);
}
export async function serviceProgramExport(params) {
  return await postRequest("programs/export", params);
}






